"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var UtilsGenericItem = __importStar(require("./generic-item"));

var UtilsRemoteItem = __importStar(require("./remote-item"));

var api_1 = __importDefault(require("../api"));

var UtilsColumnGroup = __importStar(require("./column-group"));

var UtilsFilter = __importStar(require("./filter"));

var file_cache_1 = require("./file-cache");

var app_1 = require("../configs/app");

function getWebShareLink(group) {
  return "https://".concat(app_1.WEB_DOMAIN, "/share/db/").concat(group.id);
}

exports.getWebShareLink = getWebShareLink;

function getAppShareLink(group) {
  return getAppShareLinkById(group.id);
}

exports.getAppShareLink = getAppShareLink;

function getAppShareLinkById(id) {
  return "".concat(app_1.APP_SCHEME, ":///db/").concat(id);
}

exports.getAppShareLinkById = getAppShareLinkById;

function decreasePendingItemsCount(group) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var cloned = lodash_1.default.cloneDeep(group);
  var curCount = lodash_1.default.isFinite(group.count_approved_items) ? group.count_approved_items : 0;
  var nextCount = curCount - amount;
  nextCount = Math.max(nextCount, 0);
  cloned['count_pending_items'] = nextCount;
  return cloned;
}

exports.decreasePendingItemsCount = decreasePendingItemsCount;

function resetNewPendingItemsCounter(group) {
  var cloned = lodash_1.default.cloneDeep(group);
  cloned.count_new_pending_items = 0;
  return cloned;
}

exports.resetNewPendingItemsCounter = resetNewPendingItemsCounter;

function getFilterData(group, items) {
  var advFilterOptions = lodash_1.default.get(group, 'adv_filter_options', []);
  var fromRows = items.reduce(function (acc, cur) {
    return lodash_1.default.concat(acc, UtilsGenericItem.getFilterData(cur));
  }, []);
  var merged = UtilsFilter.mergeOptionFromRows(fromRows);

  if (!lodash_1.default.isArray(advFilterOptions) || advFilterOptions.length === 0) {
    return merged;
  }

  return UtilsFilter.pickOptionGroups(merged, advFilterOptions);
}

exports.getFilterData = getFilterData;

function getQuickFilterOptions(_x) {
  return _getQuickFilterOptions.apply(this, arguments);
}

function _getQuickFilterOptions() {
  _getQuickFilterOptions = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(groupId) {
    var items;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return UtilsRemoteItem.getItemsByGroupId({
              groupId: groupId,
              isOnlyMine: false,
              isReload: false
            });

          case 2:
            items = _context.sent;
            return _context.abrupt("return", UtilsRemoteItem.getQuickFilterOptions(items));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getQuickFilterOptions.apply(this, arguments);
}

exports.getQuickFilterOptions = getQuickFilterOptions;

function getQuickFilterBundles(options, items) {
  var result = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var option = _step.value;
      var content = UtilsRemoteItem.getQuickFilterOptionContent(items, option);

      if (content === null) {
        continue;
      }

      result.push({
        option: option,
        content: content
      });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

exports.getQuickFilterBundles = getQuickFilterBundles;

function getColumnGroups(_x2) {
  return _getColumnGroups.apply(this, arguments);
}

function _getColumnGroups() {
  _getColumnGroups = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(groupId) {
    var items, groups;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return UtilsRemoteItem.getItemsByGroupId({
              groupId: groupId,
              isOnlyMine: false,
              isReload: false
            });

          case 2:
            items = _context2.sent;
            groups = items.reduce(function (acc, item) {
              return lodash_1.default.concat(acc, UtilsRemoteItem.extractColumnGroups(item));
            }, []);
            return _context2.abrupt("return", UtilsColumnGroup.deDuplicate(groups));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getColumnGroups.apply(this, arguments);
}

exports.getColumnGroups = getColumnGroups;

function getSortOptions(group) {
  return lodash_1.default.get(group, 'sort_options', []);
}

exports.getSortOptions = getSortOptions;

function getSelectedQuickFilterOptions(group) {
  return lodash_1.default.get(group, 'quick_filter_options', null);
}

exports.getSelectedQuickFilterOptions = getSelectedQuickFilterOptions;

function getPredefinedQuickFilterOptions(_x3) {
  return _getPredefinedQuickFilterOptions.apply(this, arguments);
}

function _getPredefinedQuickFilterOptions() {
  _getPredefinedQuickFilterOptions = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(group) {
    var userId, cached, ownerConfig;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (group) {
              _context3.next = 3;
              break;
            }

            console.error("group is not object: ".concat(group));
            return _context3.abrupt("return", []);

          case 3:
            userId = api_1.default.Auth.getUserIdSync();

            if (!(group.owner_id !== userId)) {
              _context3.next = 10;
              break;
            }

            _context3.next = 7;
            return file_cache_1.readQuickFilterOptions(group.id);

          case 7:
            cached = _context3.sent;

            if (!lodash_1.default.isArray(cached)) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return", lodash_1.default.sortBy(cached, ['column_title', 'row_title']));

          case 10:
            ownerConfig = getSelectedQuickFilterOptions(group);

            if (!lodash_1.default.isArray(ownerConfig)) {
              _context3.next = 13;
              break;
            }

            return _context3.abrupt("return", lodash_1.default.sortBy(ownerConfig, ['column_title', 'row_title']));

          case 13:
            return _context3.abrupt("return", null);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getPredefinedQuickFilterOptions.apply(this, arguments);
}

exports.getPredefinedQuickFilterOptions = getPredefinedQuickFilterOptions;